import Select from '@utils/common/select/module'

const select = new Select()
  .url('/srmReceiptWare/getOpenReceiptWarePage')
  .baseURL(process.env.VUE_APP_PURCHASE_API)
  .value('receiptWareNo')
  .label(option => `${option.receiptWareNo}-${option.receiptWareName}`)

export default select
